export const drawer = {
	selector: {
		wrapper: 'data-drawer-wrapper',
		own: 'data-drawer',
		handler: 'data-drawer-handler',
		sub: 'data-subdrawer',
		subHandler: 'data-subdrawer-handler',
		subClose: 'data-subdrawer-close',
	},
}
